import React, { useEffect} from "react";
import { redirectToStore } from "../../Utils/genralUtility";

const DownloadAppConfettiButton = ({ setIsExploding }) => {

  useEffect(()=>{
    setIsExploding(true);
     const timer = setTimeout(() => {
        setIsExploding(false); 
      }, 3000); 

      return () => clearTimeout(timer);
  },[])

  return (
    <>
      <button
        onClick={() => redirectToStore("click_after_submission")}
        className="px-6 py-4 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-medium">
        Download App To Check Results
      </button>
    </>
  );
};

export default DownloadAppConfettiButton;
